export default {
  // list
  'base_cost_item.query.costItemName': 'costItemName',
  'base_cost_item.query.costItemName.placeholder': 'Enter costItemName',
  'base_cost_item.query.financialName': 'financialName',
  'base_cost_item.query.financialName.placeholder': 'Enter financialName',
  'base_cost_item.query.financialCode': 'financialCode',
  'base_cost_item.query.financialCode.placeholder': 'Enter financialCode',
  'base_cost_item.column.costItemName': 'costItemName',
  'base_cost_item.column.costItemTaxRate': 'costItemTaxRate%',
  'base_cost_item.column.financialName': 'financialName',
  'base_cost_item.column.financialCode': 'financialCode',
  'base_cost_item.column.createBy': 'createBy',
  'base_cost_item.column.updateBy': 'updateBy',
  'base_cost_item.column.createTime': 'createTime',
  'base_cost_item.column.updateTime': 'updateTime',
  'base_cost_item.column.dataSource': 'dataSource',
  'base_cost_item.column.remark': 'remark',
  'base_cost_item.column.status': 'status',
  // edit
  'base_cost_item.edit.title': 'Edit BaseCostItem',
  'base_cost_item.add.title': 'Add BaseCostItem',
  'base_cost_item.edit.success': 'Edit Successful',
  'base_cost_item.add.success': 'Add Successful',
  'base_cost_item.form.costItemName.required': 'costItemName cannot be null',
  'base_cost_item.form.costItemName': 'costItemName',
  'base_cost_item.form.costItemName.placeholder': 'Enter costItemName',
  'base_cost_item.form.costItemTaxRate': 'costItemTaxRate',
  'base_cost_item.form.costItemTaxRate.placeholder': 'Enter costItemTaxRate',
  'base_cost_item.form.financialName': 'financialName',
  'base_cost_item.form.financialName.placeholder': 'Enter financialName',
  'base_cost_item.form.financialCode': 'financialCode',
  'base_cost_item.form.financialCode.placeholder': 'Enter financialCode',
}
